import { ClientPanels, ClientTabs, ClientUserProfilePanels, ClientUserProfileTabs } from "slot-definitions"
import { SecureTab, SecureTabPanel } from "minimals-template/components/secure-tabs"
import { Frag } from "lib/@components/slot/frag"
import { ClientAccess } from "./client-access"
import { UserAccess } from "./user-access"

/**
 * Access tabs (FIQ-1926).
 *
 * Gated on `admin-advanced` — the demand that already guards the Advanced tab and the CRM
 * override. Staff-only for two reasons: the breakdown resolves demands AS another client or
 * user, and the overrides editor confers capability.
 *
 * ClientTabs/ClientPanels render on both the SFG20 Admin company page and client-admin;
 * ClientUserProfileTabs/Panels render on both user profile screens. `hide` plus the demand
 * gate means a client admin never sees either.
 */

ClientTabs.plug(
    <SecureTab priority={1005} demand="admin-advanced" hide={true} fallback={<Frag />} label="Access" value="Access" />
)

ClientPanels.plug(
    <SecureTabPanel demand="admin-advanced" hide={true} fallback={<Frag />} value="Access">
        <ClientAccess $lazy />
    </SecureTabPanel>
)

ClientUserProfileTabs.plug(
    <SecureTab priority={1005} demand="admin-advanced" hide={true} fallback={<Frag />} label="Access" value="Access" />
)

ClientUserProfilePanels.plug(
    <SecureTabPanel demand="admin-advanced" hide={true} fallback={<Frag />} value="Access">
        <UserAccess $lazy />
    </SecureTabPanel>
)
